<template>
    <v-dialog style="overflow-y: hidden;" :class="isMobile ? 'mobile-modal' : 'normal-modal'" v-model="dialogControl">
        <v-card class="dialog-card">
            <v-btn @click="dialogControl = false" class="top-right-close-btn" icon>
                <v-icon>fas fa-times</v-icon>
            </v-btn>
            <v-flex v-if="!loading" class="inner-card-flex">
                <v-container v-if="hasCharges">
                    <v-data-table :headers="payTableHeaders" :items="charges" :items-per-page="5"
                        class="elevation-2 charge-table">
                        <template v-slot:item="{ item, index }">
                            <tr>
                                <td>{{ item.chargeName }}</td>
                                <td>{{ item.chargeQty }}</td>
                                <td>{{ item.chargePrice ? `$${item.chargePrice.toFixed(2)}/mnth` : 'Free' }}</td>
                                <td>
                                    <v-icon size="small" @click="deleteItem(index)">fas fa-trash</v-icon>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-container>
                <v-container v-else>
                    <h2>No Charges Currently Selected</h2>
                </v-container>
                <v-container v-if="hasCharges">
                    <v-stepper v-model="formStepper" :flat="true">
                        <v-stepper-content step="1">
                            <v-row class="center">
                                <h2>Select Payment Method</h2>
                            </v-row>
                            <v-row class="center">
                                <v-col cols="4">
                                    <v-card v-ripple :class="MethodEnum.GPay === method ? 'active' : ''"
                                        @click="method = MethodEnum.GPay" class="method-card">
                                        <div>
                                            <img :src="gPayImage" class="logo" />
                                            <p>Google Pay</p>
                                        </div>
                                    </v-card>
                                </v-col>
                                <v-col cols="4">
                                    <v-card v-ripple :class="MethodEnum.CashApp === method ? 'active' : ''"
                                        @click="method = MethodEnum.CashApp" class="method-card">
                                        <div>
                                            <img :src="cashAppImage" class="logo" />
                                            <p>Cash App</p>
                                        </div>
                                    </v-card>
                                </v-col>
                                <v-col cols="4">
                                    <v-card v-ripple :class="MethodEnum.Venmo === method ? 'active' : ''"
                                        @click="method = MethodEnum.Venmo" class="method-card">
                                        <div>
                                            <img class="logo" src="../../assets/Venmo-Logo.png" />
                                            <p>Venmo</p>
                                        </div>
                                    </v-card>
                                </v-col>
                                <v-col cols="6">
                                    <v-card v-ripple :class="MethodEnum.CC === method ? 'active' : ''"
                                        @click="method = MethodEnum.CC" class="method-card">
                                        <div>
                                            <img :src="ccImage" class="logo" />
                                            <p>Credit Card</p>
                                        </div>
                                    </v-card>
                                </v-col>
                            </v-row>
                            <v-container v-show="MethodEnum.CC === method">
                                <!--TODO: Display Screen To Generate Stripe Link-->
                                <v-row class="center">
                                    <site-button :marginNumber="10" :colNum="10" btnType="text" icon-type="SVG"
                                        :iconString="stripeLinkImg" tool-tip="Stripe Link" colorClasses="primary-icon stripe-btn"
                                        iconColor="primary-icon" @click-event="submitPayment"></site-button>
                                </v-row>
                                <!-- <v-form v-model="valid">
                                    <v-row class="center">
                                        <v-col cols="8">
                                            <v-text-field
                                                color="#00006d"
                                                class="text-field-outline"
                                                v-model="paymentInfo.ccInfo.cardHolderName"
                                                label="Cardholder Name"
                                                name="ccname"
                                                autocomplete="cc-name"
                                                outlined
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row class="center">
                                        <v-col cols="8">
                                            <v-text-field
                                                v-mask="'#### #### #### ####'"
                                                color="#00006d"
                                                class="text-field-outline"
                                                v-model="paymentInfo.ccInfo.ccNumber"
                                                label="Credit Card Number"
                                                name="paymentInfo.ccInfo.ccNumber"
                                                autocomplete="cc-number"
                                                outlined
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row class="center">
                                        <v-col cols="4">
                                            <v-text-field
                                                v-mask="'###'"
                                                color="#00006d"
                                                class="text-field-outline"
                                                v-model="paymentInfo.ccInfo.cvc"
                                                label="CVC"
                                                name="cvc"
                                                autocomplete="cc-csc"
                                                outlined
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-text-field
                                                v-mask="['##/##', '#/##']"
                                                color="#00006d"
                                                class="text-field-outline"
                                                :rules="expirationDateRules"
                                                v-model="paymentInfo.ccInfo.exp"
                                                label="Expiration Date"
                                                name="exp-date"
                                                autocomplete="cc-exp"
                                                outlined
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row class="center">
                                        <site-button
                                            v-if="showContinue"
                                            :marginNumber="1"
                                            :colNum="10"
                                            iconPosition="END"
                                            btnType="text"
                                            text="Continue"
                                            colorClasses="secondary-icon"
                                            iconColor="secondary-icon"
                                            iconString="fas fa-arrow-right"
                                            @click-event="formStepper = 2"
                                        ></site-button>
                                    </v-row>
                                </v-form> -->
                            </v-container>
                            <v-row class="center" v-show="MethodEnum.CC !== method">
                                <v-col cols="8">
                                    <v-text-field color="#00006d" class="text-field-outline" v-model="input"
                                        :label="fieldHint" outlined></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="center">
                                <v-col cols="8">
                                    <site-button v-if="input" :marginNumber="1" :colNum="10" :iconType="null" btnType="text"
                                        text="Continue" colorClasses="secondary-icon" iconColor="primary-icon"
                                        @click-event="formStepper = 2"></site-button>
                                </v-col>
                            </v-row>
                        </v-stepper-content>
                        <v-stepper-content step="2">
                            <v-row>
                                <site-button btnType="text" :colNum="2" toolTip="Back To CC Info"
                                    iconString="fa fa-arrow-left" @click-event="moveBackwards"></site-button>
                                <v-col cols="8">
                                    <h2>Enter Billing Address</h2>
                                </v-col>
                                <v-col cols="2"></v-col>
                            </v-row>
                            <business-address :address="businessAddress"></business-address>
                            <v-row class="center my-6">
                                <site-button :marginNumber="10" :colNum="10" btnType="text"
                                    iconString="fas fa-lock" text="Process Payment" colorClasses="primary-icon"
                                    iconColor="primary-icon" @click-event="submitPayment"></site-button>
                            </v-row>
                        </v-stepper-content>
                    </v-stepper>
                </v-container>
            </v-flex>
            <v-flex v-else>
                <v-col>
                    <h2>{{ loaderMessage }}</h2>
                    <v-progress-circular indeterminate :size="50" color="primary"></v-progress-circular>
                </v-col>
            </v-flex>
        </v-card>
    </v-dialog>
</template>

<style lang="scss" scoped>
@import '../../styles/styles.scss';

.stripe-btn {
    svg {
        width: 125px !important;
        height: 75px !important;
    }
}

.modal-card {
    width: 65% !important;
    max-width: 65%;
}

.charge-table {
    margin: 2em;

    tr {
        td {
            text-align: left;
        }
    }
}

::v-deep .v-dialog {
    overflow-y: hidden !important;
    border-radius: 15px;
    height: 90%;
    max-height: 90% !important;
    max-width: 60%;
}

.dialog-card {
    height: 100%;
    overflow-y: hidden;
}

.inner-card-flex {
    height: 100%;
    overflow-y: auto;
    margin-left: 0;
    margin-right: 0;
}
</style>

<script>
import SiteButton from './SiteButton'
import BusinessAddress from './Business/BusinessAddress'
import PaymentMethodEnum from '../../assets/Enums/PaymentMethodEnum'
import { mask } from 'vue-the-mask'

export default {
    name: 'payment-dialog',
    directives: {
        mask: mask,
    },
    props: {
        showDialog: {
            type: Boolean,
            default: false,
        },
        charges: {
            type: Array,
            default: () => [],
        },
    },
    components: {
        'site-button': SiteButton,
        'business-address': BusinessAddress,
    },
    data: () => ({
        formStepper: 1,
        valid: false,
        method: PaymentMethodEnum.CC,
        input: '',
        loading: false,
        loaderMessage: '',
        saveInfo: false,
        payTableHeaders: [
            { text: 'Charge Name', value: 'chargeName' },
            { text: 'Charge Qty', value: 'chargeQty' },
            { text: 'Charge Price', value: 'chargePrice' },
            { text: 'Actions', key: 'actions', sortable: false },
        ],
        firstName: '',
        lastName: '',
        paymentInfo: {
            venmo: null,
            cashApp: null,
            gPay: null,
            ccInfo: {
                cardHolderName: '',
                ccNumber: '',
                zipCode: '',
                exp: '',
                cvc: 0,
            },
        },
        businessAddress: {
            city: '',
            line1: '',
            line2: '',
            state: {
                abbreviation: '',
                name: '',
            },
            zipCode: '',
        },
    }),
    methods: {
        deleteItem(index) {
            this.$store.dispatch('DELETE_CHARGE', index)
        },
        async submitPayment() {
            const data = JSON.parse(JSON.stringify(this.$data))

            delete data.valid;
            delete data.input;
            delete data.formStepper;
            delete data.payTableHeaders;
            delete data.loading;
            delete data.loaderMessage;

            this.loading = true;
            await this.$store.dispatch('SUBMIT_PAYMENT', { ...data, charges: this.charges });
            console.log('submitted');
            this.dialogControl = false;
            this.loading = false;
            this.loaderMessage = '';
        },
        resetForm() { },
        moveBackwards() {
            if (this.formStepper > 0) {
                this.formStepper--
            }
        },
    },
    computed: {
        dialogControl: {
            get() {
                return this.showDialog
            },
            set(newVal) {
                this.formStepper = 1
                this.$emit('set-dialog-control', newVal)
            },
        },
        MethodEnum() {
            return PaymentMethodEnum
        },
        fieldHint() {
            return this.method + ' Username'
        },
        isMobile() {
            return screen.width <= 760
        },
        gPayImage() {
            return require('../../assets/G-Pay-Logo.svg')
        },
        ccImage() {
            return require('../../assets/Credit-Card-Logo.svg')
        },
        cashAppImage() {
            return require('../../assets/Cash-App-Logo.svg')
        },
        venmoImage() {
            return require('../../assets/Venmo-Logo.svg')
        },
        stripeLinkImg() {
            return require('../../assets/Stripe-Link.svg');
        },
        hasCharges() {
            return this.charges.length > 0
        },
        showContinue() {
            switch (this.method) {
                case PaymentMethodEnum.CC: {
                    return (
                        this.paymentInfo.ccInfo.cardHolderName &&
                        this.paymentInfo.ccInfo.exp &&
                        this.paymentInfo.ccInfo.cvc &&
                        this.paymentInfo.ccInfo
                    )
                }
                case PaymentMethodEnum.CashApp: {
                    return this.paymentInfo.cashApp
                }
                case PaymentMethodEnum.GPay: {
                    return this.paymentInfo.gPay
                }
                case PaymentMethodEnum.Venmo: {
                    return this.paymentInfo.venmo
                }
                default: {
                    return false
                }
            }
        },
        showSubmit() {
            return (
                this.businessAddress.city &&
                this.businessAddress.line1 &&
                this.businessAddress.state.abbreviation &&
                this.businessAddress.state.name &&
                this.businessAddress.zipCode
            )
        },
        expirationDateRules() {
            return [
                v => (parseInt(v.substring(0, 2)) < 13 && parseInt(v.substring(0, 2)) > 0) || 'Invalid expiration date',
            ]
        },
        dialogTitle() {
            return this.formStepper === 1 ? 'Select Payment Method' : 'Billing Address'
        },
    },
}
</script>